import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { SortableElement } from 'react-sortable-hoc'

const style = theme => ({
	root: {

	},
	divider: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
})

const SortableItem = SortableElement(({
	formikProps,
	i,
	id,
	classes,
	children,
	...other
}) => {
	return children(formikProps, id, i)
})


SortableItem.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(SortableItem);